import { Grid, Typography } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'

import { CartFragment } from '../../../graphql/magento'
import SummarySectionHeader from './SummarySectionHeader'

export interface AddressSummaryProps {
  address:
    | NonNullable<CartFragment['billing_address']>
    | NonNullable<CartFragment['shipping_addresses'][number]>
  className?: string
  navigateTo?: string
  showEdit?: boolean
  title: string
}

const StyledRecipientName = styled(Typography)`
  && {
    font-weight: bold;
    margin-bottom: 0;
  }
`

const AddressSummary: React.FC<AddressSummaryProps> = ({
  address,
  className,
  navigateTo,
  showEdit = false,
  title,
}) => {
  return (
    <Grid className={className} container item xs={12}>
      <SummarySectionHeader title={title} navigateTo={navigateTo} showEdit={showEdit} />
      <Grid item xs={12}>
        <StyledRecipientName variant="body2" gutterBottom className="fs-exclude">
          {`${address.firstname} ${address.lastname}`}
        </StyledRecipientName>
        {address.street.reduce((acc: React.ReactElement[], street, index) => {
          if (!street) return acc
          acc.push(
            <Typography key={index} variant="body2" className="fs-exclude">
              {street}
            </Typography>,
          )
          return acc
        }, [])}
        <Typography variant="body2" paragraph>
          {`${address.city}${address.region ? `, ${address.region.code}` : ''} ${
            address.postcode
          }, ${address.country.code}`}
        </Typography>
        {address.telephone && (
          <Typography variant="body2" className="fs-exclude">
            {address.telephone}
          </Typography>
        )}
      </Grid>
    </Grid>
  )
}

const StyledAddressSummary = styled(AddressSummary)`
  border-top: 1px solid ${({ theme }) => theme.colors.component.checkoutBorderLight};
  padding: 15px 15px 20px;
  @media (min-width: 600px) {
    border-left: 1px solid ${({ theme }) => theme.colors.component.checkoutBorderLight};
    border-right: 1px solid ${({ theme }) => theme.colors.component.checkoutBorderLight};
  }
`

export default StyledAddressSummary
